import { render, staticRenderFns } from "./IconOrganizerSignup.vue?vue&type=template&id=b228bd28"
import script from "./IconOrganizerSignup.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconOrganizerSignup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports